import isValidHttpUrl from './isValidHttpUrl';

/**
 * Opens a url in a popup window.
 * @param {string} url - requested url
 * @param {string} windowName - if specified, the name of the browsing context
 * @param {string} windowFeatures - containing a comma-separated list of window features
 */
export const openRequestedPopup = (url, windowName, windowFeatures) => {
  if (isValidHttpUrl(url)) window.open(url, windowName, windowFeatures);
};

export default openRequestedPopup;
